export const mergeSx = (...sxObjects) => {
  const finalSx = [];
  sxObjects.forEach((item) => {
    finalSx.push(...(Array.isArray(item) ? item : [item]));
  });
  return finalSx;
};
